var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homepage"}},[_c('Hero'),_c('USP'),_c('Carousel'),_c('About'),_c('Prizes'),_c('Benefits'),_c('Schedule'),_c('Sponsors'),_c('Faq'),_c('Contact'),_c('Foot'),_c('Backdrop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }